// tslint:disable:no-empty-interface
// tslint:disable:max-line-length
// tslint:disable: no-use-before-declare
import {ITCIApplication, TCITenantAppType} from "./tci-application";
import {Observable, Subject} from "rxjs";
import {strEnum} from "../../types";

import {
    ITCIApplicationRequest,
    ITCIApplicationResponse,
    ITCITenantRequest,
    ITCITenantResponse,
    ITCITenantServiceProvider
} from "./tci-tenant";
import {ITCIUserInfo} from "./tci-user";
import {ITCIFileMap} from "./tci-util";
import {ITCIValidationResult, TCIActionValidationResult} from "./tci-validation";
import {ITCISupplement} from "./tci-supplements";
import {ITCIMarketplaceConnector} from "./tci-marketplace";
import {
    ITCIExecHistoryDetailResponse,
    ITCIExecHistoryProcessListResponse,
    ITCIExecHistoryProcessResponse,
    ITCIExecHistoryResponse,
    TCIExecHistorySortableColumn,
    TCIExecHistoryStatus
} from "./tci-exec-history";

/**
 * TCI SERVICE_PROVIDER_TYPES
 * @type {{[K in string]: K}}
 */
export const TCI_TENANT_ENVIRONMENT_TYPE = strEnum([
    "FLOGO_ENTERPRISE"
]);
export type TCI_TENANT_ENVIRONMENT_TYPE = keyof typeof TCI_TENANT_ENVIRONMENT_TYPE;

/**
 *
 */
export interface ITCIApplicationEnvironmentProvider extends ITCITenantServiceProvider {
    /**
     * Returns an envrionment var val
     * @param type
     */
    getEnviroment<T>(type: TCI_TENANT_ENVIRONMENT_TYPE): T;
}

/*************************************************************************************************/
/**
 * Delete Application Input Object
 */

export interface ITCIApplicationDeleteRequest extends ITCIApplicationRequest {
}

/**
 * Delete Appliction Response object
 */
export interface ITCIApplicationDeleteResponse extends ITCIApplicationResponse {
}

/**
 * Application Delete Provider
 */
export interface ITCIApplicationDeleteProvider extends ITCITenantServiceProvider {
    /**
     *
     * @param input
     */
    canDeleteApplication(input: ITCIApplicationDeleteRequest): Observable<boolean>;

    /**
     *
     * @param input
     */
    deleteApplication(input: ITCIApplicationDeleteRequest): Observable<ITCIApplicationDeleteResponse>;

}

/**
 * Execution History Provider
 */
export interface ITCIApplicationExecHistoryProvider extends ITCITenantServiceProvider {
    /**
     * Get execution history list
     * @param appType: application type
     * @param appId: application Id
     * @param processStartTime: start time
     * @param processEndTime: end time
     * @param page: page number
     * @param limit: limit per page
     * @param processName: execution history item process name
     * @param status: execution history item status
     * @param searchText: search text
     * @param sortColumn: sortable column, default is startTime
     * @param sortDesc: sort order, default is true, descending
     */
    getExecHistory(appType: TCITenantAppType, appId: string,
                   processStartTime: number, processEndTime: number,
                   page?: number, limit?: number,
                   processName?: string, status?: TCIExecHistoryStatus, searchText?: string,
                   sortColumn?: TCIExecHistorySortableColumn, sortDesc?: boolean): Observable<ITCIExecHistoryResponse>;

    /**
     * Get execution history list
     * @param appType: application type
     * @param appId: application Id
     * @param processStartTime: start time
     * @param processEndTime: end time
     * @param processName: execution history item process name
     * @param appNodeName: app instance id
     * @param processInstanceJobId: process instance job id
     * @param sortColumn: sortable column, default is startTime
     * @param sortDesc: sort order, default is true, descending
     */
    getExecHistoryChildListByJobId(appType: TCITenantAppType, appId: string,
                                   processStartTime: number, processEndTime: number,
                                   processName: string, appNodeName: string, processInstanceJobId: string,
                                   sortColumn?: TCIExecHistorySortableColumn, sortDesc?: boolean): Observable<ITCIExecHistoryProcessResponse>;

    /**
     * Get execution history process list
     * @param appType: application type
     * @param appId: application Id
     * @param processStartTime: start time
     * @param processEndTime: end time
     */
    getExecHistoryProcessList(appType: TCITenantAppType, appId: string,
                              processStartTime: number, processEndTime: number): Observable<ITCIExecHistoryProcessListResponse>;

    /**
     * Get execution history detail
     * @param appType: application type
     * @param appId: application Id
     * @param processName: execution history item process name
     * @param appNodeName: app instance id
     * @param processInstanceJobId: process instance job id
     * @param processStartTime: process start time
     * @param processEndTime: process end time
     */
    getExecHistoryDetail(appType: TCITenantAppType, appId: string,
                         processName: string, appNodeName: string, processInstanceJobId: string,
                         processStartTime: number, processEndTime: number): Observable<ITCIExecHistoryDetailResponse>;
}

/*************************************************************************************************/

/*************************************************************************************************/
/**
 * TCI_EXTENSION_ACTION_TYPE
 * @type {{[K in string]: K}}
 */
export const TCI_EXTENSION_ACTION_TYPE = strEnum([
    "EXTENSION_INSTALL",
    "EXTENSION_DELETE"
]);
export type TCI_EXTENSION_ACTION_TYPE = keyof typeof TCI_EXTENSION_ACTION_TYPE;

export interface ITCIExtensionInstallRequest {
    /**
     * tenant app type
     */
    tenantType: TCITenantAppType;
    /**
     * action type
     */
    actionType: TCI_EXTENSION_ACTION_TYPE;

}

export interface ITCIExtensionInstallResponse {

}

/**
 *  Extension Provider
 */
export interface ITCIExtensionProvider extends ITCITenantServiceProvider {
    /**
     *
     * @param input
     */
    canInstallExtension(input: ITCIExtensionInstallRequest): Observable<boolean>;

    /**
     *
     */
    installExtension(input: ITCIExtensionInstallRequest): Observable<ITCIExtensionInstallResponse>;

}

/*************************************************************************************************/
export const TCI_APP_CUSTOMIZATION_TYPE = strEnum([
    "GLOBAL_NAVBAR",
    "HELP_PANEL",
    "DOCUMENT_TITLE",
    "PENDO",
    "APP_MAIN_MENU_MARKETPLACE",
    "APP_MAIN_MENU_EXTENSIONS",
    "APP_MAIN_MENU_ENV_TOOLS",
    "APP_LIST_HEADER_MONITORING",
    "APP_LIST_FILTERS",
    "APP_LIST_FILTERS_APP_CATEGORY",
    "APP_LIST_FILTERS_DEPLOY_CATEGORY",
    "APP_LIST_FILTERS_STATUS_CATEGORY",
    "APP_LIST_FILTERS_APP_OWNER",
    "APP_LIST_FILTER_TAGS",
    "APP_LIST_COL_WIDTH",
    "APP_LIST_COL_CATEGORY",
    "APP_LIST_COL_INSTANCES",
    "APP_LIST_COL_LAST_RUN",
    "APP_LIST_COL_STATUS",
    "APP_LIST_COL_DEPLOYMENT",
    "APP_LIST_ROW_PEEK_VIEW",
    "APP_LIST_ROW_HAMBURGER",
    // "APP_DETAIL_DEPLOY",
    "APP_DETAIL_HEADER_CATEGORY",
    "APP_DETAIL_HEADER_CREATED_BY",
    "APP_DETAIL_HEADER_TAGS",
    "APP_CREATE",
    "CONNECTIONS_LIST_FILTER",
    "CONNECTIONS_LIST_COL_CATEGORY",
    "CONNECTIONS_LIST_COL_VISIBILITY",
    "CONNECTIONS_LIST_ROW_HAMBURGER",
    "MARKETPLACE_LIST_FILTER",
    "APP_LIST_PEEK_VIEW",
    "TCI_SCRIPTS_GOOGLE",
    "TCI_SCRIPTS_PENDO",
    "TCI_SCRIPTS_SYNERGY_ASR"
]);

export type TCI_APP_CUSTOMIZATION_TYPE = keyof typeof TCI_APP_CUSTOMIZATION_TYPE | string;

// export interface ITCIAppListCustomization {
//     /**
//      * get Customizations for a given type
//      * @param type
//      */
//     getCustomizationParam(type: TCI_APP_CUSTOMIZATION_TYPE): ITCIAppCustomizationParam;
//
//     /**
//      * set Customization Param
//      * @param type
//      * @param param
//      */
//     setCustomizationParam(type: TCI_APP_CUSTOMIZATION_TYPE, param: ITCIAppCustomizationParam);
// }

/**
 *  Determines which aspects of a User interface is being customized in association
 *  with @{TCI_APP_CUSTOMIZATION_TYPE}. The TCI Ws app needs to be abstracted from
 *  Tenant needs using @{ITCIAppCustomizationProvider}
 */
export interface ITCIAppCustomizationParam {
    /**
     * if a param is a tenant customization param(true) or a default param (false)
     */
    tenantCustomization: boolean;
    /**
     * if a given @{TCI_APP_CUSTOMIZATION_TYPE} is visible
     */
    visible: boolean;
    /**
     * if a given @{TCI_APP_CUSTOMIZATION_TYPE} is enabled
     */
    enabled: boolean;
    /**
     * if the tenant wants to substitute a different label string
     */
    label: string;
    /**
     * if the tenant wants to substitute a different image (Header only)
     */
    imageUrl: string;
    /**
     * if the tenant wants to substitute a different css to the @{TCI_APP_CUSTOMIZATION_TYPE}
     * (Not implemented)
     */
    styleCss: string;
}

/**
 * interface ITCIAppCustomizationRequest
 */
export interface ITCIAppCustomizationRequest extends ITCITenantRequest {
    /**
     * type of customization area
     */
    type: TCI_APP_CUSTOMIZATION_TYPE;
    /**
     * any associated input data
     */
    data?: any;
}

/**
 * interface ITCIAppCustomizationResponse
 */
export interface ITCIAppCustomizationResponse extends ITCITenantResponse {
    /**
     * Application Response status
     */
    success: boolean;
    /**
     * Application Response message
     */
    msg?: string;
    /**
     * ApplicationCreation data to be returned
     */
    result?: any | ITCIFileMap | ITCIAppCustomizationParam;
}

/**
 * interface @ITCIAppCustomizationProvider
 * This provider is intended to be implemented by only one tenant i.e.
 * Flogo Enterprise Tenant which needs to customize TCI UI
 * The TCI SDK/UI does not support multiple Customization Provider,
 * if there are multiple customization providers present it means it is in TCI mode
 * as compared to Flogo Enterprise mode. The Flogo tenant on the other hand
 * knows based on its deployment that it is running in Flogo Enterprise or Flogo TCI mode.
 * The TCI code abstracts the customization changes by type and affected areas
 */
export interface ITCIAppCustomizationProvider extends ITCITenantServiceProvider {
    /**
     * get customizations
     * @param input
     */
    getCustomizations(input: ITCIAppCustomizationRequest): Observable<ITCIAppCustomizationResponse>;
}

/********************************************************************************/
export const TCI_TENANT_SUPPLEMENT_ACTION_TYPE = strEnum([
    "CREATE",
    "UPDATE",
    "DELETE",
    "DOWNLOAD",

]);

/**
 * Supplement data
 */
export interface ITCITenantSupplementParam {

}

export type TCI_TENANT_SUPPLEMENT_ACTION_TYPE = keyof typeof TCI_TENANT_SUPPLEMENT_ACTION_TYPE | string;

export interface ITCITenantSupplementRequest extends ITCITenantRequest {
    /**
     * Supplement Name
     */
    name?: string;
    /**
     * Supplement Id
     */
    supplementId?: string;
    /**
     *  App Creation Data to be uploaded
     */
    appData?: ITCIFileMap | Uint8Array | any;
    /**
     * connector id
     */
    connectorId?: string;
    /**
     *  User Info
     */
    userInfo?: ITCIUserInfo;
}

export interface ITCITenantSupplementResponse extends ITCITenantResponse {
    /**
     * Supplement Response status
     */
    success: boolean;
    /**
     * Supplement Response message
     */
    msg?: string;
    /**
     * ApplicationCreation data to be returned
     */
    result?: any | ITCIFileMap | ITCITenantSupplementParam;

}

/**
 *
 */
export class SupplementValidationResult extends TCIActionValidationResult implements ITCITenantSupplementResponse {
    /**
     * Application Id
     */
    supplementId: string;
    /**
     * Application Name
     */
    name: string;
    /**
     * Application Response status
     */
    success: boolean;
    /**
     * Application Response message
     */
    msg?: string;
    /**
     * ApplicationCreation data to be returned
     */
    result?: any | ITCIFileMap;

}

export interface ITCISupplementConnector {
    /**
     * connector Id
     */
    id: string;
    /**
     * connector name
     */
    name: string;
}

/**
 * ITCITenantSupplementProvider
 */
export interface ITCISupplementServiceProvider extends ITCITenantServiceProvider {
    /**
     * Check before calling uploadSupplement
     * The tenant needs to check if upload conditions are correct
     * and the TCI UI will use the result to enable/disable the Upload button
     * @param input
     */
    canCreate(input: ITCITenantSupplementRequest): Observable<boolean | ITCIValidationResult>;

    /**
     * Validate before uploading if there are content errors
     * The validation result can be an error or warning
     * The errors needs to be shown on the Drag-Drop UI.
     * After success the  can be called.
     * @param input
     */
    validate(input: ITCITenantSupplementRequest): Observable<ITCIValidationResult>;

    /**
     * upload Supplement - This is where the tenant code will call the {TciTenantBaseSupplementSharedService}
     * `super.uploadSupplement()` for common uploading work and on completion will do its own housekeeping
     * @param input
     */
    createSupplement(input: ITCITenantSupplementRequest): Observable<ITCITenantSupplementResponse>;

    /**
     * Return a list of tenant specific supplements, the UI will use this to get supplements before
     * doing aggregation of the combined list, one from each tenant
     */
    getSupplements(): Observable<ITCISupplement[]>;

    /**
     * Get List of Supplement Connectors
     * @param input
     */
    getAllSupplementConnectors(input: ITCITenantSupplementRequest): Observable<ITCISupplementConnector[]>;


    /**
     * Get List of Connected Applications
     * @param input
     */
    getConnectedAppsById(input: ITCITenantSupplementRequest): Observable<ITCIApplication[]>;

    /**
     * download Supplement - The download action menu item visible/not visible is controlled by the
     * tenant preloadMap for the menu item selector by using canLoadComponent.
     * download Supplement will start downloading one or more files
     * @param input
     */
    downloadSupplement(input: ITCITenantSupplementRequest): Observable<ITCITenantSupplementResponse>;

    /**
     * Check before calling updateSupplement
     * @param input
     */
    canUpdate(input: ITCITenantSupplementRequest): Observable<boolean | ITCIValidationResult>;

    /**
     * update Supplement
     * @param input
     */
    updateSupplement(input: ITCITenantSupplementRequest): Observable<ITCITenantSupplementResponse>;

    /**
     * Check before calling deleteSupplement
     * @param input
     */
    canDelete(input: ITCITenantSupplementRequest): Observable<boolean | ITCIValidationResult>;

    /**
     * delete Supplement
     * @param input
     */
    deleteSupplement(input: ITCITenantSupplementRequest): Observable<ITCITenantSupplementResponse>;

    /**
     * Supplement status subject
     */
    getStatusSubject(): Subject<ITCITenantSupplementResponse>;

    /**
     * This function is wrapping the AO call by waiting
     * for the Supplement Status notification to be triggered via the refresh timer loop and
     * pass the completion status notifications back to the caller with callback
     * results and intermediate and end statuses.The Caller must subscribe for notifications.
     * @param input: @ITCITenantSupplementRequest
     * @param callback: (cinput: @ITCITenantSupplementRequest) => @Observable<@ITCITenantSupplementResponse>
     * @return @Observable<@ITCITenantSupplementResponse>
     */
    pushSuppChanges(input: ITCITenantSupplementRequest,
        callback: (cinput: ITCITenantSupplementRequest) =>
            Observable<ITCITenantSupplementResponse>): Observable<ITCITenantSupplementResponse>;

    /**
     * Return an observable indicating if the provider is busy or not
     * The provider is busy when polling for supplement upload status and until
     * it gets "Completed" signal from AO.
     * @param input
     */
    isBusy(input: ITCITenantSupplementRequest): Observable<boolean>;
}
